import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const API_BASE = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

function studentKey(student) {
  return (
    student?.student_enrollment_no ||
    student?.student_id ||
    student?.enrollment_no ||
    ""
  );
}

const MdlSelectMultipleServiceStudent = ({
  actionClose,
  actionDone,
  serviceId,
  initiallySelected = [],
}) => {
  const loggedIn = localStorage.getItem("token") !== null;
  const abortRef = useRef(null);

  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_START_DATE, setSessionStartDate] = useState("");
  const [StudentList, setStudentList] = useState([]);
  const [selectedMap, setSelectedMap] = useState(() => {
    const map = {};
    (initiallySelected || []).forEach((s) => {
      const id = studentKey(s);
      if (id) map[id] = s;
    });
    return map;
  });

  useEffect(() => {
    const session = SessionManager.getCurrentSession()?.[0];
    if (session) {
      setSESSION_ID(session.session_id || "");
      setSESSION_NAME(session.session_name || "");
      setSessionStartDate(session.start_date || "");
    }
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, []);

  const selectedCount = useMemo(
    () => Object.keys(selectedMap).length,
    [selectedMap]
  );

  const handleClose = useCallback(() => {
    setShow(false);
    actionClose();
  }, [actionClose]);

  const toggleStudent = useCallback((item) => {
    if (item.service_status === "Granted") {
      myToast.notify_warning("Already Granted");
      return;
    }
    const id = studentKey(item);
    if (!id) return;
    setSelectedMap((prev) => {
      const next = { ...prev };
      if (next[id]) delete next[id];
      else next[id] = item;
      return next;
    });
  }, []);

  const toggleAllEligible = useCallback(() => {
    const eligible = StudentList.filter(
      (s) => String(s.service_status || "").toLowerCase() !== "granted"
    );
    if (!eligible.length) return;

    setSelectedMap((prev) => {
      const allSelected = eligible.every((s) => prev[studentKey(s)]);
      if (allSelected) {
        const next = { ...prev };
        eligible.forEach((s) => {
          delete next[studentKey(s)];
        });
        return next;
      }
      const next = { ...prev };
      eligible.forEach((s) => {
        const id = studentKey(s);
        if (id) next[id] = s;
      });
      return next;
    });
  }, [StudentList]);

  const handleDone = useCallback(() => {
    const selected = Object.values(selectedMap);
    if (!selected.length) {
      myToast.notify_warning("Select at least one student");
      return;
    }
    const resolvedStartDate =
      SESSION_START_DATE ||
      SessionManager.getCurrentSession()?.[0]?.start_date ||
      localStorage.getItem("START_DATE") ||
      "";
    actionDone(selected, SESSION_ID, SESSION_NAME, resolvedStartDate);
  }, [
    selectedMap,
    SESSION_START_DATE,
    SESSION_ID,
    SESSION_NAME,
    actionDone,
  ]);

  const getStudentList = useCallback(
    (class_id, section_id, session_id) => {
      if (abortRef.current) abortRef.current.abort();
      const controller = new AbortController();
      abortRef.current = controller;

      setLoading(true);
      setStudentList([]);

      axios
        .get(`${API_BASE}getServiceRecepientStudent.php`, {
          params: {
            school_code: SessionManager.getSchoolCode(),
            class_id,
            section_id,
            service_id: serviceId,
            session_id,
          },
          signal: controller.signal,
        })
        .then((res) => res.data)
        .then((response) => {
          if (controller.signal.aborted) return;
          setLoading(false);
          if (response.api_status === "OK") {
            setStudentList(response.data || []);
          } else {
            myToast.notify_warning(response.api_remark);
          }
        })
        .catch((error) => {
          if (
            axios.isCancel?.(error) ||
            error?.name === "CanceledError" ||
            error?.code === "ERR_CANCELED"
          ) {
            return;
          }
          setLoading(false);
          console.error("Error fetching student list:", error);
        });
    },
    [serviceId]
  );

  const CallBackClassSelect = useCallback(
    (
      class_id,
      section_id,
      session_id,
      _selected_position,
      _class_name,
      _section_name,
      session_name,
      start_date
    ) => {
      setSESSION_ID(session_id);
      setSESSION_NAME(session_name);
      setSessionStartDate(
        start_date ||
          SessionManager.getCurrentSession()?.[0]?.start_date ||
          ""
      );
      getStudentList(class_id, section_id, session_id);
    },
    [getStudentList]
  );

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  const eligibleCount = StudentList.filter(
    (s) => String(s.service_status || "").toLowerCase() !== "granted"
  ).length;
  const allEligibleSelected =
    eligibleCount > 0 &&
    StudentList.filter(
      (s) => String(s.service_status || "").toLowerCase() !== "granted"
    ).every((s) => selectedMap[studentKey(s)]);

  return (
    <>
      <style>
        {`
          .modal-content {
            border-radius: 16px !important;
            border: none !important;
            overflow: hidden !important;
          }
          .modal-header {
            border-radius: 16px 16px 0 0 !important;
            border: none !important;
          }
          .modal-body {
            border: none !important;
          }
          .modal-footer {
            border: none !important;
            border-radius: 0 0 16px 16px !important;
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        style={{ opacity: 1 }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modern-modal"
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
            color: COLORS.white,
            border: "none",
            borderRadius: "16px 16px 0 0",
            padding: "20px 24px",
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{
              fontSize: "20px",
              fontWeight: "700",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(10px)",
              }}
            >
              <i className="fa fa-users" style={{ fontSize: "20px" }} />
            </div>
            Select Multiple Students
            {selectedCount > 0 ? (
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 13,
                  fontWeight: 700,
                  padding: "4px 10px",
                  borderRadius: 999,
                  background: "rgba(255,255,255,0.22)",
                }}
              >
                {selectedCount} selected
              </span>
            ) : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: "24px",
            background: "#f8fafc",
            border: "none",
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          <div style={{ position: "relative" }}>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(255, 255, 255, 0.9)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                  borderRadius: "16px",
                }}
              >
                <MyLoader />
              </div>
            )}

            <div
              style={{
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: 1, minWidth: 240 }}>
                <SelectClass action={CallBackClassSelect} selected_position="0" />
              </div>
              {eligibleCount > 0 ? (
                <button
                  type="button"
                  onClick={toggleAllEligible}
                  style={{
                    border: "1.5px solid #03a9f4",
                    background: allEligibleSelected ? "#e1f5fe" : "#fff",
                    color: "#0288d1",
                    borderRadius: 10,
                    padding: "8px 14px",
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                  {allEligibleSelected ? "Clear all" : "Select all"}
                </button>
              ) : null}
            </div>

            {StudentList.length === 0 && !loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  background: "white",
                  borderRadius: "12px",
                  border: "2px dashed #e2e8f0",
                }}
              >
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "20px",
                    background: `linear-gradient(135deg, ${(COLORS.primary_color || "#3b82f6")}20 0%, ${(COLORS.primary_color_shade4 || "#2563eb")}10 100%)`,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "20px",
                  }}
                >
                  <i
                    className="fa fa-user-graduate"
                    style={{
                      fontSize: "40px",
                      color: COLORS.primary_color || "#3b82f6",
                      opacity: 0.6,
                    }}
                  />
                </div>
                <p
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: "#374151",
                  }}
                >
                  No Students Found
                </p>
                <p style={{ fontSize: "14px", color: "#6b7280" }}>
                  Please select a class to view students.
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
                  gap: "16px",
                }}
              >
                {StudentList.map((item) => {
                  const id = studentKey(item);
                  const isGranted = item.service_status === "Granted";
                  const isSelected = !!selectedMap[id];
                  return (
                    <div key={id}>
                      <div
                        onClick={() => toggleStudent(item)}
                        style={{
                          background: isSelected ? "#e1f5fe" : "white",
                          borderRadius: "16px",
                          padding: "12px",
                          border: isSelected
                            ? "2px solid #03a9f4"
                            : "2px solid #e5e7eb",
                          cursor: isGranted ? "not-allowed" : "pointer",
                          opacity: isGranted ? 0.65 : 1,
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: 10,
                            left: 10,
                            width: 22,
                            height: 22,
                            borderRadius: 6,
                            border: isSelected
                              ? "none"
                              : "2px solid #81d4fa",
                            background: isSelected
                              ? "linear-gradient(135deg, #03a9f4 0%, #0288d1 100%)"
                              : "#fff",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 11,
                            zIndex: 2,
                          }}
                        >
                          {isSelected ? (
                            <i className="fa fa-check" />
                          ) : null}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            alignItems: "center",
                            flex: 1,
                            paddingLeft: 18,
                          }}
                        >
                          <div
                            style={{
                              width: "70px",
                              height: "70px",
                              borderRadius: "14px",
                              background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                              flexShrink: 0,
                              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            {item.student_img_path ? (
                              <img
                                src={item.student_img_path}
                                alt={item.stu_name || "Student"}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.parentElement.innerHTML = `<i class="fa fa-user" style="font-size: 32px; color: white;"></i>`;
                                }}
                              />
                            ) : (
                              <i
                                className="fa fa-user"
                                style={{ fontSize: "32px", color: "white" }}
                              />
                            )}
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <h5
                              style={{
                                margin: "0 0 6px 0",
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "#111827",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.stu_name || "N/A"}
                            </h5>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "3px",
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  fontWeight: "500",
                                }}
                              >
                                <span
                                  style={{ fontWeight: "600", color: "#374151" }}
                                >
                                  Father:
                                </span>{" "}
                                {item.father_name || "N/A"}
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  color: "#6b7280",
                                  fontWeight: "500",
                                }}
                              >
                                <span
                                  style={{ fontWeight: "600", color: "#374151" }}
                                >
                                  Enrollment:
                                </span>{" "}
                                {item.student_enrollment_no || "N/A"}
                              </p>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                  color: "#9ca3af",
                                }}
                              >
                                <span
                                  style={{ fontWeight: "600", color: "#6b7280" }}
                                >
                                  Village:
                                </span>{" "}
                                {item.village_town || "N/A"}
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "8px",
                              flexShrink: 0,
                              minWidth: "100px",
                            }}
                          >
                            <div
                              style={{
                                padding: "4px 10px",
                                borderRadius: "16px",
                                fontSize: "10px",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                background: isGranted
                                  ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                                  : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              {isGranted ? "Granted" : "Available"}
                            </div>
                            <div
                              style={{
                                width: "45px",
                                height: "45px",
                                borderRadius: "10px",
                                background: `linear-gradient(135deg, ${COLORS.primary_color || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "700",
                              }}
                            >
                              {item.class?.[0]?.student_roll_no || "N/A"}
                            </div>
                            <div
                              style={{
                                textAlign: "center",
                                fontSize: "11px",
                                fontWeight: "600",
                                color: "#374151",
                                maxWidth: "90px",
                              }}
                            >
                              Class:{" "}
                              {item.class?.[0]?.section_id === "No"
                                ? item.class?.[0]?.class_name || "N/A"
                                : `${item.class?.[0]?.class_name || "N/A"}:${item.class?.[0]?.section_name || "N/A"}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            background: "#fff",
            padding: "14px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 650, color: "#475569" }}>
            {selectedCount} student{selectedCount === 1 ? "" : "s"} selected
          </span>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                border: "1.5px solid #cbd5e1",
                background: "#fff",
                color: "#334155",
                borderRadius: 10,
                padding: "10px 18px",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleDone}
              style={{
                border: "none",
                background: `linear-gradient(135deg, ${COLORS.primary_color || "#03a9f4"} 0%, ${COLORS.primary_color_shade4 || "#0288d1"} 100%)`,
                color: "#fff",
                borderRadius: 10,
                padding: "10px 20px",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Done ({selectedCount})
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MdlSelectMultipleServiceStudent;
